import { render, staticRenderFns } from "./OnlineCultureGeneral.vue?vue&type=template&id=6a80069e&"
import script from "./OnlineCultureGeneral.vue?vue&type=script&lang=ts&"
export * from "./OnlineCultureGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports